<template>
  <div
    :class="
      `dropdown-categories-block ${isShowFixedCategoryBlock ? 'show' : ''}`
    "
  >
    <div class="dropdown-header-block">
      <p class="dropdown-header-title">{{ title }}</p>
      <div>
        <button
          v-if="type !== 'currency'"
          class="settings-button"
          @click.stop="isOpenSettingsPage"
        >
          <settings-icon class="settings-icon" />
        </button>
        <button
          class="create-bayment-close-button"
          @click.stop="onCloseFixedBlock"
        >
          <x-icon class="create-payment-close-icon" />
        </button>
      </div>
    </div>
    <div class="search-input-container">
      <search-icon class="search-icon" @click.stop="" />
      <input
        v-model="filterText"
        type="text"
        class="search-category-input"
        :placeholder="
          type === 'currency'
            ? $t('homePage.fixedListPlaceholderCurrency')
            : $t('homePage.fixedListPlaceholder')
        "
        @click.stop=""
      />
    </div>
    <vue-perfect-scrollbar
      class="list-scroll-area"
      :style="{
        maxHeight: type === 'currency' ? '55vh' : '65vh',
      }"
    >
      <div
        v-for="item of filteredOption"
        :key="item.id"
        class="categories-item"
        @click.stop="setCheckElement(item)"
      >
        <div v-if="item.img" class="category-icon-container">
          <img
            :src="item.img"
            accept="image/svg+xml"
            alt="SVG Icon"
            class="category-icon"
          />
        </div>
        <div
          v-else-if="!item.img && type !== 'currency'"
          class="category-icon-container"
        >
          <question-mark-icon class="category-icon" />
        </div>
        <div v-else class="category-icon-container">
          <dollar-sign-icon class="category-icon" color="#ffffff" />
        </div>
        <p v-if="type !== 'currency'" class="categories-item-text">
          {{ item.title }}
        </p>
        <p v-else class="categories-item-text">{{ item.code_alfa }}</p>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  XIcon,
  SearchIcon,
  SettingsIcon,
  DollarSignIcon,
} from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import QuestionMarkIcon from "../resources/js/icons/QuestionMarkIcon.vue";

export default {
  name: "Fixed-bottom-list",
  components: {
    XIcon,
    QuestionMarkIcon,
    VuePerfectScrollbar,
    SettingsIcon,
    SearchIcon,
    DollarSignIcon,
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    isShowFixedCategoryBlock: {
      type: Boolean,
      require: true,
    },
    list: {
      type: Array,
      require: false,
    },
    type: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      filteredOption: [],
      filterText: "",
    };
  },
  async mounted() {
    if (this.type === "currency") {
      this.filteredOption = this.list.data;
    }
  },

  methods: {
    isOpenSettingsPage() {
      this.$emit("set-is-open-fixed-list");
      this.$emit("set-is-open-settings-category");
    },
    onCloseFixedBlock() {
      this.filterText = "";
      this.$emit("set-is-open-fixed-list");
    },
    setCheckElement(value) {
      this.filterText = "";
      this.$emit("on-check-item-list", value);
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  computed: {},
  watch: {
    list(newVal, oldVal) {
      console.log({ newVal }, "data");
      let val = oldVal;
      val;
      this.filteredOption = newVal;
    },
    filterText(newVal, oldVal) {
      let val = oldVal;
      val;
      if (this.type === "currency") {
        if (newVal?.length >= 1) {
          const regex = new RegExp(".*" + newVal + ".*", "i");
          let newArray = this.list.filter((item) => regex.test(item.code_alfa));
          this.filteredOption = newArray;
        } else {
          this.filteredOption = this.list;
        }
      } else {
        if (newVal?.length >= 1) {
          const regex = new RegExp(".*" + newVal + ".*", "i");
          let newArray = this.list.filter((item) => regex.test(item.title));
          this.filteredOption = newArray;
        } else {
          this.filteredOption = this.list;
        }
      }
    },
  },
};
</script>

<style scoped>
.dropdown-categories-block {
  position: fixed;
  width: 100%;
  z-index: 1000000000;
  height: 80vh;
  left: 0px;
  bottom: 0px;
  background: #e8e8e8;
  transform: translateY(100%);
  transition: all 0.5s ease;
  border: 1px solid rgba(0, 0, 0, 0.07);
}

.dropdown-categories-block.show {
  transform: translateY(0);
}

.categories-item {
  display: flex;
  gap: 15px;
  background: transparent;
  padding: 15px 10px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.categories-item-text {
  font-weight: 400;
  line-height: 40px;
  font-size: 15px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  transition: all 0.25s ease;
}

.categories-item:hover {
  background-image: var(--main-bg-color);
  color: #fff;
}

.categories-item:hover p {
  color: #fff;
}

.category-icon-container {
  position: relative;
  width: 45px;
  height: 45px;
  background-image: var(--main-bg-color);
  border-radius: 50%;
  display: flex;
  z-index: 10;
  transition: all 0.25s ease;
}

.category-icon-container:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}

.category-icon {
  margin: auto;
  color: #fff;
  width: 25px;
}

.dropdown-header-block {
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
  /* border-bottom: 2px solid rgba(0, 0, 0, 0.07); */
}

.dropdown-header-title {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.list-scroll-area {
  width: 100%;
  padding-bottom: 20px;
}

@media (max-height: 500px) {
  .list-scroll-area {
    padding-bottom: 40px;
  }
}

.create-bayment-close-button {
  cursor: pointer;
  background: transparent;
  border: none;
}

.settings-button {
  border: none;
  background: transparent;
  cursor: pointer;
  margin-right: 15px;
}

.settings-icon {
  color: rgba(0, 0, 0, 0.5);
}

.create-payment-close-icon {
  width: 26px;
  height: 26px;
  color: #d84558;
}

.search-category-input {
  display: flex;
  width: 95%;
  padding: 15px 10px 15px 40px;
  border-radius: 10px;
  background: #e8e8e8;
  outline: none;
  border: 1px rgba(0, 0, 0, 0.09) solid;
  margin: 0 auto;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  font-weight: 400;
  line-height: 1.5;
}

.search-category-input:placeholder {
  color: rgba(0, 0, 0, 0.05);
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  font-weight: 400;
  line-height: 1.5;
}

.search-input-container {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
